package com.fireavert.properties.property_details.client.presentation

import com.fireavert.fire_risk.data_models.TenantFireRiskDataModel
import com.fireavert.properties.shared.data_models.Mode
import com.fireavert.properties.shared.data_models.PmsType

data class PropertyDetailsViewState(
    val propertyName: String = "",
    val isLoading: Boolean = false,
    val propertyMode: Mode? = null,
    val propertyTotalUnits: Int = 0,
    val isAdmin: Boolean = false,
    val loading: Boolean = false,
    val testModeError: String = "",
    val isTestModeDialogOpen: Boolean = false,
    val fireRiskModel: List<TenantFireRiskDataModel> = emptyList(),
    val pmsType: PmsType? = null,
    val propertyDefaultStoveCookingTimeMinutes: Int = 40,
)